// SECTION - AUTH
// SECTION - APP
// SECTION - SYSTEM
export const CENTERAL_POINT_URL_DOMAIN = 'CENTERAL_POINT_URL_DOMAIN';
// SECTION - ERRORS
export const RESET_API_ERRORS = 'RESET_API_ERRORS';